export const APP_CONTACT_US_EMAIL = 'hello@askaimi.app';